import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerXMemberClub } from "src/models/Customers/MemberClub.models";

interface CustomerXMemberClubState {
  customerXMemberClubs: ICustomerXMemberClub[];
  customerXMemberClubToEdit: ICustomerXMemberClub | null;
}

const initialState: CustomerXMemberClubState = {
  customerXMemberClubs: [],
  customerXMemberClubToEdit: null,
};

const customerXMemberClubSlice = createSlice({
  name: "CustomerXMemberClub",
  initialState,
  reducers: {
    setCustomerXMemberClubList: (
      state,
      action: PayloadAction<ICustomerXMemberClub[]>
    ) => {
      state.customerXMemberClubs = action.payload;
    },
    concatListCustomerXMemberClub: (
      state: CustomerXMemberClubState,
      action: PayloadAction<ICustomerXMemberClub[]>
    ) => {
      state.customerXMemberClubs = [
        ...state.customerXMemberClubs.concat(action.payload),
      ];
    },
    setCustomerXMemberClubToEdit: (
      state,
      action: PayloadAction<ICustomerXMemberClub | null>
    ) => {
      state.customerXMemberClubToEdit = action.payload;
    },
    addCustomerXMemberClub: (
      state,
      action: PayloadAction<ICustomerXMemberClub>
    ) => {
      state.customerXMemberClubs.push(action.payload);
    },
    updateCustomerXMemberClub: (
      state,
      action: PayloadAction<ICustomerXMemberClub>
    ) => {
      let itemIndex = state.customerXMemberClubs.findIndex(
        item =>
          // action.payload.isInList
          // ? item.memberClubId === action.payload.memberClubId
          /*:*/ item.customerXMemberClubId ===
          action.payload.customerXMemberClubId
      );
      if (itemIndex !== -1)
        state.customerXMemberClubs[itemIndex] = action.payload;
    },
    deleteCustomerXMemberClub: (
      state,
      action: PayloadAction<ICustomerXMemberClub>
    ) => {
      const newArray = state.customerXMemberClubs.filter(item =>
        action.payload.isInList
          ? item.memberClubId !== action.payload.memberClubId
          : item.customerXMemberClubId !== action.payload.customerXMemberClubId
      );
      state.customerXMemberClubs = newArray;
    },
  },
});

export const {
  setCustomerXMemberClubList,
  concatListCustomerXMemberClub,
  setCustomerXMemberClubToEdit,
  addCustomerXMemberClub,
  updateCustomerXMemberClub,
  deleteCustomerXMemberClub,
} = customerXMemberClubSlice.actions;

export default customerXMemberClubSlice.reducer;
